import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "../CsStyles";

import { Box, Button, TextField } from "@material-ui/core";

class Import extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: ""
        };
        this.container = this.props.container;
    }

    importData = (data) => {
        var lines = data.split("\n");
        this.container.setState({ parseBars: [] });

        lines.forEach(line => {
            const typeRegex = /type\s*=\s*\"?(?<type>\w+)\"?/;
            const lineRegex = /(?<name>\w+)\s*=\s*\{(?<prefix>.*?)node\s*=\s*(?:\"|\')(?<value>[\"\'\s\w\/]*)(?:\"|\')(?<postfix>.*?)\}/;

            var match = line.match(typeRegex);
            if (match !== null) {
                this.container.setState({ type: match.groups.type.toLowerCase() });
                return;
            }

            match = line.match(lineRegex);
            if (match === null)
                return;

            var attributes = [];

            var attrStrings = match.groups.postfix.split(',').filter(e => e.trim());
            attrStrings.forEach(attr => {
                var values = attr.split('=');

                attributes.push({
                    name: values[0].trim('"'),
                    value: values.length < 2 ? "" : values[1].replace(/^(['"\s]+)|(['"\s]+)$/gm, '')
                });
            });
            this.container.addBar(match.groups.name, match.groups.value, attributes);
        });
    }

    render() {
        return (
            <Box>
                <TextField
                    variant="outlined"
                    fullWidth
                    multiline
                    onChange={e => this.setState({ value: e.target.value })} />
                <Button id="importBtn" onClick={() => {
                    this.importData(this.state.value);
                }}>
                    Import
                </Button>
            </Box> 
    )}
}

export default withStyles(styles)(Import);